import { Component, Emit, Inject, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import JhiDataUtils from '@/shared/data/data-utils.service';
import { mixins } from 'vue-class-component';
import { BvTableFieldArray } from 'bootstrap-vue';
import { GeneracionSnp, ListarGeneracionSnp, RelacionAlumnoSnp } from '@/shared/model/snp/generaciones.model';
import SolicitudService from '@/entities/solicitud/solicitud.service';

@Component
export default class GeneracionesListadoComponent extends mixins(JhiDataUtils, ApeironComponent) {
  @Inject('solicitudService') private readonly solicitudService: () => SolicitudService;

  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return false;
    },
  })
  public actualizarTabla: boolean;

  public filtroGeneracion = '';
  public generacionesFiltradas: Array<ListarGeneracionSnp> = [];
  public generaciones: Array<ListarGeneracionSnp> = [];
  public perPage = 15;
  public currentPage = 1;
  public mostrarModalEliminar = false;
  public consultandoTabla = false;

  public generacionSeleccionada: GeneracionSnp = new GeneracionSnp();

  public readonly fieldsGeneraciones: BvTableFieldArray = [
    {
      key: 'generacion.fechaGeneracion',
      label: this.$t('apeironGwApp.generacionesSnp.form.fechaGeneracion').toString(),
      class: 'text-left',
    },
    {
      key: 'relacionAlumno.alumnos',
      label: this.$t('apeironGwApp.generacionesSnp.form.alumnos').toString(),
      class: 'text-left',
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.generacionesSnp.acciones.acciones').toString(),
      class: 'text-center btn-acciones',
      thStyle: { width: '10rem' },
      thClass: this.esEscritura ? '' : 'd-none',
      tdClass: this.esEscritura ? '' : 'd-none',
    },
  ];

  public mounted(): void {
    this.iniciarComponente();
  }

  @Watch('actualizarTabla')
  private refrescarTabla(): void {
    this.iniciarComponente();
  }

  private iniciarComponente(): void {
    this.generacionSeleccionada = new GeneracionSnp();
    this.consultandoTabla = true;

    this.generaciones = [];
    (this.solicitud?.generaciones ?? []).forEach(generacion => {
      this.generaciones.push(new ListarGeneracionSnp(generacion, undefined));
    });
    this.buscarEnGeneraciones();

    this.solicitudService()
      .obtenerConteosDeGeneracionesAlumnos(this.solicitud.id)
      .then(generaciones => {
        const generacionesMap: Map<string, RelacionAlumnoSnp> = new Map();
        generaciones.forEach(generacion => generacionesMap.set(generacion.generacion, generacion));

        this.generaciones = [];

        (this.solicitud?.generaciones ?? []).forEach(generacion => {
          this.generaciones.push(new ListarGeneracionSnp(generacion, generacionesMap.get(generacion.fechaGeneracion)));
        });

        this.buscarEnGeneraciones();
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.consultandoTabla = false;
      });
  }

  public mostrarModalEliminarGeneracion(generacion: GeneracionSnp): void {
    this.generacionSeleccionada = GeneracionSnp.fromObject(generacion);
    this.mostrarModalEliminar = true;
  }

  public eliminarGeneracion(): void {
    if (this.esEscritura) {
      this.quitarGeneracion();
    }
    this.mostrarModalEliminar = false;
  }

  @Emit('eliminarGeneracion')
  public quitarGeneracion(): Array<GeneracionSnp> {
    if (this.generacionSeleccionada.id) {
      return (this.solicitud.generaciones ?? []).filter(generacion => generacion.id != this.generacionSeleccionada.id);
    } else if (this.generacionSeleccionada.cveGeneracion) {
      return (this.solicitud.generaciones ?? []).filter(
        generacion => generacion.cveGeneracion != this.generacionSeleccionada.cveGeneracion
      );
    }
  }

  public buscarEnGeneraciones(): void {
    this.generacionesFiltradas = [];
    const generaciones = [];

    this.generaciones.forEach(generacion => {
      if (this.filtroGeneracion) {
        if (generacion?.generacion.fechaGeneracion?.toLowerCase().includes(this.filtroGeneracion.toLowerCase())) {
          generaciones.push(generacion);
        }
      } else {
        generaciones.push(generacion);
      }
    });

    this.generacionesFiltradas = generaciones.sort((g1, g2) =>
      g1.generacion?.fechaGeneracion > g2.generacion?.fechaGeneracion
        ? -1
        : g1.generacion?.fechaGeneracion < g2.generacion?.fechaGeneracion
        ? 1
        : 0
    );
  }

  get registros(): number {
    return this.generacionesFiltradas?.length ?? 0;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
